<template>
  <evalmee-chip
    v-if="!online"
    color="red"
    label
    icon="mdi-wifi-off"
    v-on="on"
    small
    v-tooltip="$t('live.navBar.offline.tooltip')"
  >
    {{ $t("live.navBar.offline.chip") }}
  </evalmee-chip>
</template>


<script>
import { useOnline } from "@vueuse/core"
import EvalmeeChip from "@/components/shared/evalmee_chip.vue"

export default {
  name: "OfflineChip",
  components: { EvalmeeChip },
  setup() {

    const online = useOnline()
    return {
      online,
    }
  },
}
</script>